import { Link } from "react-router-dom";

export type Crumb = {
  label: string;
  path?: string;
};

type BreadcrumbsProps = {
  items: Crumb[];
};

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      ...(item.path
        ? { item: `${window.location.origin}${item.path}` }
        : {}),
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <nav aria-label="面包屑导航" className="w-full">
        <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500 md:text-sm">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={`${item.label}-${index}`} className="flex items-center gap-2">
                {item.path && !isLast ? (
                  <Link
                    to={item.path}
                    className="cursor-pointer whitespace-nowrap transition-colors hover:text-primary-600"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span
                    className={`whitespace-nowrap ${isLast ? "text-foreground-800" : ""}`}
                    aria-current={isLast ? "page" : undefined}
                  >
                    {item.label}
                  </span>
                )}
                {!isLast && (
                  <span className="flex h-4 w-4 items-center justify-center text-foreground-300">
                    <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}